import Slider from '../slider';
import './postcard.css';

export default (element) => {
  const createSlider = () => {
    const slider = new Slider({
      el: element.querySelector('[data-postcard-slider]'),
      options: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: '!hidden',
        },
      },
    });
    return slider;
  };

  createSlider();
};
